import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css"; // <-- Works AFTER npm install
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="lux-footer py-5">
      <div className="container">

        <div className="row gy-5 align-items-start justify-content-between">

          
          {/* BRAND */}
          <div className="col-12 col-lg-4 text-center text-lg-start">
            <h3 className="lux-brand">Aditya Exports Ventures</h3>
            <p className="lux-tagline">
              Premium Indian Coffee • Certified Quality • Trusted Worldwide
            </p>
            <p className="lux-mini-text mt-3">
              Delivering excellence through ethical sourcing, precision processing,
              and world-class export expertise.
            </p>
          </div>

          {/* NAVIGATION */}
          <div className="col-12 col-lg-3 text-center">
            <h5 className="lux-title">Quick Navigation</h5>
            <ul className="list-unstyled lux-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              {/* <li><a href="/farm">Our Farm</a></li> */}
              {/* <li><a href="/coffee">Our Coffee</a></li> */}
              <li><a href="/coffee/green">Green Coffee Beans</a></li>
              <li><a href="/coffee/roasted">Roasted Coffee Beans</a></li>
              <li><a href="/certificates">Certificates</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* CONTACT + SOCIAL */}
          <div className="col-12 col-lg-4 text-center text-lg-end">
            <h5 className="lux-title">Reach Us</h5>

            {/* SOCIAL ICONS */}
            <div className="lux-social mt-3">
                  <a
                    href="https://www.instagram.com/adityaexportsventures/?igsh=MWliNHZ4N3JhMjA5eg%3D%3D&utm_source=qr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/aditya-exports-ventures/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>

                <a 
                  href="https://wa.me/919552794179?text=Hello%20Aditya%20Exports%20Ventures!%20I%20am%20interested%20in%20your%20coffee%20beans."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-whatsapp"></i>
                </a>
              </div>


            {/* EMAIL + PHONE */}
            <p className="lux-email mt-3">info@adityaexportsventures.com</p>
            <p className="lux-phone">+91 95527 94179</p>
            <p className="lux-phone">+91 83085 99393</p>
            <p className="lux-Available">Available 24/7 for Trade Inquiries</p>

            {/* SINGLE INDIA OFFICE */}
            <div className="lux-locations mt-4">
              <h6 className="lux-location-title">Our Office</h6>

              <p className="lux-location">
                <span className="flag-icon">🇮🇳</span>
                <strong> Headquarters – India</strong><br />
                Hadapsar, Pune, Maharashtra
              </p>
            </div>
          </div>

        </div>

        {/* DIVIDER */}
        <div className="lux-divider mt-4"></div>

        {/* COPYRIGHT */}
        <p className="text-center lux-copy mt-3">
          © 2026 Aditya Exports Ventures — Premium Coffee Exporters
        </p>

      </div>
    </footer>
  );
}
